import React from 'react';
import { motion } from 'framer-motion';

const Products = () => {
  // 👉 Put your WhatsApp number here in international format, without "+" or spaces
  const WHATSAPP_NUMBER = '919876543210'; // 🔁 CHANGE THIS

  const products = [
    {
      id: 1,
      name: 'Mens Collar Matty T Shirts',
      image:
        'https://5.imimg.com/data5/SELLER/Default/2024/3/397320690/LW/QF/QD/119448501/mens-collar-matty-t-shirts-1000x1000.jpeg',
    },
    {
      id: 2,
      name: 'Polo T Shirt',
      image:
        'https://5.imimg.com/data5/SELLER/Default/2024/3/397183230/JV/HD/IB/119448501/whatsapp-image-2024-03-07-at-2-11-15-pm-500x500.jpeg',
    },
    {
      id: 3,
      name: 'Men Light Grey Collar Cotton T Shirt',
      image:
        'https://5.imimg.com/data5/SELLER/Default/2024/3/397182485/KW/FQ/VM/119448501/whatsapp-image-2024-03-07-at-2-11-10-pm-1-500x500.jpeg',
    },
    {
      id: 4,
      name: 'Polo T Shirt',
      image:
        'https://5.imimg.com/data5/SELLER/Default/2024/3/397319707/OI/LQ/AL/119448501/men-s-color-pure-cotton-t-shirt-500x500.jpg',
    },
  ];

  const getWhatsAppLink = (productName) => {
    const message = `Hi, I am interested in your t-shirts`;
    return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
  };

  return (
    <section id="products" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4 md:px-6">
      <div className="flex justify-center mb-8">
               <motion.div
                 className="inline-flex items-center gap-2 rounded-full bg-gray-900 px-6 py-2 shadow-lg"
                 initial={{ opacity: 0, y: 20 }}
                 whileInView={{ opacity: 1, y: 0 }}
                 viewport={{ once: true }}
                 transition={{ duration: 0.7, delay: 0.15 }}
               >
                 <span className="h-2.5 w-2.5 rounded-full bg-yellow-400" />
                 <span className="font-playfair font-bold text-lg md:text-xl text-white">
                  Featured Products
                 </span>
               </motion.div>
             </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {products.map((product, index) => (
            <motion.div
              key={product.id}
              className="bg-white rounded-2xl shadow-md overflow-hidden border border-gray-100 hover:shadow-xl transition-shadow duration-300 flex flex-col h-full"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              whileHover={{ y: -8 }}
            >
              {/* Image */}
              <div className="h-64 bg-gray-100 flex items-center justify-center">
                <img
                  src={product.image}
                  alt={product.name}
                  className="max-h-full max-w-full object-contain"
                />
              </div>

              {/* Content */}
              <div className="flex flex-col flex-1 p-5">
                <h3 className="text-lg md:text-xl font-playfair font-bold text-gray-900 mb-3">
                  {product.name}
                </h3>

                {/* Button fixed to bottom of card */}
                <div className="mt-auto">
                  <a
                    href={getWhatsAppLink(product.name)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center rounded-full bg-amber-700 text-white px-4 py-2 text-sm font-semibold hover:bg-amber-800 transition-colors w-full text-center"
                  >
                    Inquire via WhatsApp
                  </a>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Products;
